import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private router: Router) { }

  handleUnauthorizedError(error: any): void {
    // console.error('Unauthorized error:', error);
    // this.router.navigate(['/login']);
  }
}
